import { toast } from "react-toastify";

export function Toaster(type, toastMessage, durationInMs = 3000) {
    switch (type) {
        case "error":
            return toast.error(toastMessage, {
                position: "top-right",
                className: "toast-error",
                autoClose: durationInMs,
                toastId: "error",
            });
        case "success":
            return toast.success(toastMessage, {
                position: "top-right",
                className: "toast-success",
                autoClose: durationInMs,
                toastId: "success",
            });
        default:
            return null;
    }
}